import { Box, Card, Grid, useMediaQuery } from '@mui/material';
import PageContainer from 'src/components/container/PageContainer';
import VerifyRegister from './auth/Verify';

const Verify = () => {
  const sm = useMediaQuery((theme) => theme.breakpoints.down('md'));
  return (
    <PageContainer title="Verification" description="Enter Email OTP For Verification">
      <Box
        sx={{
          position: 'relative',
          '&:before': {
            content: '""',
            background: 'radial-gradient(#d2f1df, #d3d7fa, #bad8f4)',
            backgroundSize: '400% 400%',
            animation: 'gradient 15s ease infinite',
            position: 'absolute',
            height: '100%',
            minHeight: '700px',
            width: '100%',
            opacity: '0.3',
          },
        }}
      >
        <Grid container spacing={0} justifyContent="center" sx={{ height: '100vh' }}>
          <Grid
            item
            xs={12}
            sm={12}
            lg={4}
            xl={3}
            display="flex"
            justifyContent="center"
            alignItems="center"
          >
            <Card
              elevation={9}
              sx={{
                p: 4,
                paddingLeft: sm ? '1rem' : 3,
                zIndex: 1,
                width: '100%',
                maxWidth: '500px',
                minHeight: '75%',
                paddingTop: '15%',
              }}
            >
              <VerifyRegister />
            </Card>
          </Grid>
        </Grid>
      </Box>
    </PageContainer>
  );
};

export default Verify;
